import React, { createRef, RefObject } from 'react';
import { InstagramEmbed } from 'react-social-media-embed';
import ParagraphProps from '@src/components/Paragraph/paragraph-props';
import { useMedia } from 'react-use';

const InstagramParagraph = ({ paragraph }: ParagraphProps) => {
  const el: RefObject<HTMLDivElement> = createRef();
  const isMobile = useMedia('(max-width: 576px)', true);

  return (
    <section ref={el} className="paragraph instagram-paragraph">
      <InstagramEmbed url={paragraph.data.url} width={isMobile ? 320 : 500} />
    </section>
  );
};

export default InstagramParagraph;
